export enum DistanceSliderPosition {
  NAV_BAR = 'NAV_BAR',
  MODAL = 'MODAL'
}
